import { render, staticRenderFns } from "./index.vue?vue&type=template&id=68a76d0c"
import script from "./transferAsset.js?vue&type=script&lang=js&external"
export * from "./transferAsset.js?vue&type=script&lang=js&external"
import style0 from "./transferAsset.css?vue&type=style&index=0&prod&lang=css&external"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports